"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section className="relative h-screen w-full overflow-hidden">
      {}
      <video autoPlay muted loop playsInline className="absolute inset-0 h-full w-full object-cover">
        <source src="/img/hero_background_video.mp4" type="video/mp4" />
      </video>

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-dark-background/80 via-dark-background/60 to-dark-background/90" />

      {}
      <div className="relative z-10 flex h-full items-center justify-center px-4">
        <div ref={ref} className={`max-w-3xl text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {}
          <div className="rounded-xl bg-gradient-to-br from-dark-background/70 via-dark-background/50 to-dark-background/60 p-10 backdrop-blur-md shadow-[0_8px_32px_rgba(0,0,0,0.3),0_2px_8px_rgba(0,0,0,0.2)] border border-white/10 hover:shadow-[0_12px_48px_rgba(0,0,0,0.4),0_4px_12px_rgba(0,0,0,0.3)] hover:border-white/20 transition-all duration-500 ease-[var(--ease-out-back)] flex items-center justify-center">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_n19p3ri3.jpg" alt="The Mass - A Philip Gray Production" className="w-full h-auto max-w-2xl rounded-md shadow-medium" />
          </div>
        </div>
      </div>
    </section>;
}